<template>
	<div class="input__container">
		<!--<label v-if="label.length > 0">{{ label }}</label>-->
		<span v-if="label" class="number-input__label">
			{{ label }}
			<span v-if="mandatory" class="number-input__mandatory">*</span>
		</span>
		<span v-if="underlabel" class="number-input__underlabel">
			{{ underlabel }}
		</span>
		<div
			:class="[
				'number-input',
				hideButtons ? 'number-input--alternate' : '',
				mandatory ? 'number-input--mandatory' : '',
				hasError ? 'number-input--error' : '',
				lightTheme ? 'number-input--light-theme' : ''
			]"
		>
			<Button
				:class="['btn--left']"
				v-if="!hideButtons"
				:data-id="dataId"
				color="dark"
				@click.native="decrement($event.target.getAttribute('data-id'))"
				:disabled="currentValue == minNumber || disableMinus == true"
			>
				<svg width="14" height="2" viewBox="0 0 14 2" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon icon-notification'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M0 2V0h14v2z" fill="#FFF" fill-rule="evenodd"/></svg>
			</Button>
			<input
				type="number"
				:placeholder="placeholderValue"
				:data-id="dataId"
				:min="minNumber"
				:max="maxNumber"
				:disabled="hideButtons == true ? false : true"
				:value="parseInt(currentValue)"
				@change="
					setValue($event.target.getAttribute('data-id'), $event.target.value)
				"
			/>
			<Button
				:class="['btn--right']"
				v-if="!hideButtons"
				:data-id="dataId"
				color="dark"
				@click.native="
					disablePlus == false
						? increment($event.target.getAttribute('data-id'))
						: () => {}
				"
				:disabled="disablePlus"
			>
				<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon icon-notification'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M6.055 14V7.925H0V6.04h6.055V0h1.82v6.04H14v1.885H7.875V14z" fill="CurrentColor" fill-rule="evenodd"/></svg>
			</Button>
		</div>
		<span v-if="errorMessage != ''" class="number-input__error">
			{{ errorMessage }}
		</span>
	</div>
</template>

<script>
import Button from './Button.vue'

export default {
	name: 'NumberComponent',
	components: {
		Button
	},
	data() {
		return {
			currentValue: this.initalValue
		}
	},
	props: {
		dataId: {
			type: [String, Number],
			default: 0
		},
		minNumber: {
			type: [String, Number],
			default: 0
		},
		maxNumber: {
			type: [String, Number],
			default: 20
		},
		initalValue: {
			type: [String, Number],
			default: 0
		},
		label: {
			type: String,
			default: ''
		},
		underlabel: {
			type: String,
			default: ''
		},
		hideButtons: {
			type: Boolean,
			default: false
		},
		errorMessage: {
			type: String,
			default: ''
		},
		hasError: {
			type: Boolean,
			default: false
		},
		mandatory: {
			type: Boolean,
			default: false
		},
		disablePlus: {
			type: Boolean,
			default: false
		},
		disableMinus: {
			type: Boolean,
			default: false
		},
		placeholderValue: {
			type: String,
			default: ''
		},
		lightTheme: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		decrement(id) {
			if (this.disableMinus !== true) {
				if (this.currentValue > 0 && this.currentValue !== this.minNumber) {
					this.currentValue = Number(this.currentValue) - 1
				}

				const val = this.currentValue
				this.$emit('number-input', val, id)
			}
		},
		increment(id) {
			this.currentValue = Number(this.currentValue) + 1
			if (this.currentValue > this.maxNumber) {
				this.currentValue = this.maxNumber
			}

			const val = this.currentValue
			this.$emit('number-input', val, id)
		},
		setValue(id, value) {
			this.currentValue = value

			if (this.currentValue > this.maxNumber) {
				this.currentValue = this.maxNumber
			}
			if (this.currentValue < 0) {
				this.currentValue = 0
			}

			const val = parseInt(this.currentValue)
			this.$emit('number-input', val, id)
		}
	}
}
</script>

<style scoped lang="scss">
.btn--left {
	border-radius: 3px 0 0 3px;
}
.btn--right {
	border-radius: 0px 3px 3px 0;
}
.input__container {
	label {
		font-size: 20px;
		+ * {
			margin-top: $spacing2;
		}
	}
}
.accordion {
	.input__container {
		padding-top: 5px;
		padding-bottom: 20px;
		@include for-tablet-portrait-up {
			padding-bottom: 5px;
		}
	}
}

.number-input {
	display: flex;
	input[type='number']::-webkit-inner-spin-button,
	input[type='number']::-webkit-outer-spin-button {
		-webkit-appearance: none;
	}
	input[type='number'] {
		-moz-appearance: textfield;
	}
	input {
		box-sizing: border-box;
		padding: 0;
		font-size: 20px;
		text-align: center;
		outline: 0;
		background: $colorInputBackground;
		box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.2);
		border: 0;
		max-width: 46px;
		width: 46px;
		//width: 32px;
		//height: 32px;
		height: 40px;
		margin: 0;
		padding: $spacing1;
		@include for-tablet-portrait-up {
			height: 30px;
			font-size: 16px;
			padding: $spacing1;
		}
		&::placeholder {
			font-weight: 300;
			color: #7f8ba1;
		}
	}
	&__label {
		display: block;
		color: #697791;
		font-family: Saira;
		font-size: 15px;
		line-height: 24px;
		margin-bottom: 5px;
	}
	&__underlabel {
		display: block;
		color: #697791;
		font-family: Saira;
		font-size: 13px;
		line-height: 24px;
		margin-top: -10px;
		margin-bottom: 5px;
	}
	&__mandatory {
		font-size: 15px;
		color: $colorRed;
		margin-left: -3px;
	}
	&__error {
		color: $colorRed;
		display: inline-block;
		font-size: 15px;
		line-height: 15px;
		margin-top: 15px;
	}

	button {
		max-width: 40px;
		min-width: auto;
		position: relative;
		padding: 0 15px;
		//height: 32px;
		height: 40px;
		width: 32px;
		min-width: 32px;
		@include for-tablet-portrait-up {
			padding: 0;
			height: 30px;
		}

		> svg {
			pointer-events: none;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	&--alternate {
		input {
			font-family: Saira, sans-serif;
			text-align: left;
			padding: 0 0 0 12px;
			max-width: 100%;
			font-size: 16px;
			height: $input-field-height;
			line-height: 32px;
			font-weight: 300;
			color: $colorPrimary;
			width: 100%;
			border-radius: 5px;
		}
	}
	&--mandatory {
		// input {
		// 	border: 2px solid #64c7bc;
		// }
	}
	&--error input:not(.number-input--error) {
		color: $colorWhite;
		background: $colorRed;
		border: none;
	}
	&--error input::placeholder {
		color: $colorWhite;
	}
	&--light-theme {
		input {
			background: #fff;
			border: 1px solid #bfc5cf;
		}
		// &.number-input--error {
		// 	background: #e15b5b;
		// }
	}
}

.accordion-fieldset {
	.number-input__error {
		font-size: 10px;
		line-height: 15px;
		margin-top: 0;
		position: relative;
		top: 1px;
	}
}
</style>
